<script setup lang="ts">
import { ref } from 'vue';
import FavoriteGroupsSheet from '@/components/layout/FavoriteGroupsSheet.vue';
import NetworkBadge from '@/components/ui/NetworkBadge.vue';
import { useGroupStore } from '@/stores/group';

const groupStore = useGroupStore();
const isSheetOpen = ref(false);
</script>

<template>
  <template v-if="groupStore.group">
    <button
      :aria-label="$t('favoriteGroups.open', { name: groupStore.group.name })"
      aria-haspopup="dialog"
      class="network-button"
      type="button"
      @click="isSheetOpen = true"
    >
      <NetworkBadge
        :name="groupStore.group.name"
        :color="groupStore.group.color"
        :logo-url="groupStore.group.logo_url"
      />
    </button>
    <FavoriteGroupsSheet v-model:open="isSheetOpen" />
  </template>
</template>

<style lang="scss">
.network-button {
  --network-badge-height: 38px;

  align-items: center;
  background-color: $color-white;
  border: 1px solid $color-border-light;
  border-radius: $radius-xl;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 52px;
  justify-content: center;
  padding: 0;
  pointer-events: auto;
  width: 52px;

  // Square whatever the logo's ratio: a wide logo shrinks rather than eating into the search bar.
  .network-badge {
    justify-content: center;
    width: 38px;

    &__logo {
      max-width: 100%;
    }
  }
}
</style>
